import { inject, Injectable } from '@angular/core';
import { BaseService } from '@shared/core';
import { Observable } from 'rxjs';
import { IBaseFilterParams, IParkingLotItem } from '@pkp-g/core';

@Injectable({
  providedIn: 'root',
})
export class ParkingLotsService {
  private http = inject(BaseService);
  apiUrl = 'v1/parking-lots';

  getAllParkingLots(filter?: IBaseFilterParams): Observable<IParkingLotItem[]> {
    return this.http.get(this.apiUrl, filter);
  }

  setParkingLot(payload: IParkingLotItem): Observable<string> {
    return this.http.post(this.apiUrl, payload);
  }

  getParkingLotById(id: string): Observable<IParkingLotItem> {
    return this.http.get(this.apiUrl + '/' + id);
  }

  updateParkingLotById(id: string, payload: IParkingLotItem): Observable<unknown> {
    return this.http.put(this.apiUrl + '/' + id, payload);
  }

  deleteParkingLot(id: string): Observable<unknown> {
    return this.http.delete(this.apiUrl + '/' + id);
  }
}
